import { type ReactNode, createContext, useContext, useMemo } from "react";
import type { useDRDP } from "./logics";

const Context = createContext<ReturnType<typeof useDRDP> | undefined>(undefined);

export const useDRDPContext = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useDRDPContext must be within DRDPProvider");
  }

  return context;
};

type IDRDP = ReturnType<typeof useDRDP> & {
  children: ReactNode;
};

export const DRDPProvider = ({ children, ...props }: IDRDP) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const value = useMemo(
    () => props,
    [
      props.monthYearRange,
      props.setMonthYearRange,
      props.selectRange,
      props.handleMouseEnter,
      props.handleMouseLeave,
      props.handleSelect,
      props.isSelected,
      props.isBetween,
    ]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
